export const LogsType = {
  SELENIUM: "selenium",
  CONSOLE: "console",
  TERMINAL: "terminal",
  TELEMETRY: "telemetry",
  CYPRESS_CONSOLE: "cypress-console",
  CDP_CONSOLE: "cdp-console",
  DEVICE_LOGS: "devicelog"
};

export const LogsName = {
  selenium: "Selenium Logs",
  console: "Console Logs",
  terminal: "Terminal Logs",
  telemetry: "Telemetry Logs",
  appium: "Appium Logs",
  devicelog: "Device Logs"
};
